import { TFunction } from "i18next";
import { TravelSectionSettingsResource } from "../../../shared/types";
import { GuestTravelFormValues } from "../../../shared/types/travel";

export interface TravelValidationResult {
	travels?: Record<number, string[]>;
	count?: string;
}

export const validateTravels = (
	settings: TravelSectionSettingsResource,
	travels: GuestTravelFormValues[],
	t: TFunction,
): TravelValidationResult | null => {
	const result: TravelValidationResult = {};

	const travelErrors = travels.reduce(
		(errors, travel, index) => {
			const messages: string[] = [];

			if (
				travel.departures.length === 0 &&
				!travel.departureInquiry &&
				!travel.departureSelfTravel &&
				!travel.departureTravelTemplate
			) {
				messages.push(t("You have to provide a departure."));
			}

			if (
				travel.arrivals.length === 0 &&
				!travel.arrivalInquiry &&
				!travel.arrivalSelfTravel &&
				!travel.arrivalTravelTemplate
			) {
				messages.push(t("You have to provide an arrival."));
			}

			if (messages.length === 0) {
				return errors;
			}

			return {
				...errors,
				[index]: messages,
			};
		},
		{} as Record<number, string[]>,
	);

	if (Object.keys(travelErrors).length > 0) {
		result.travels = travelErrors;
	}

	if (settings.minTravels !== null && travels.length < settings.minTravels) {
		result.count = t("You need to have at least {{count}} travels.", { count: settings.minTravels });
	}

	if (settings.maxTravels !== null && travels.length > settings.maxTravels) {
		result.count = t("You can only assign a maximum of {{count}} travels.", { count: settings.maxTravels });
	}

	if (Object.keys(result).length > 0) {
		return result;
	} else {
		return null;
	}
};
